exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logout-button{position:fixed;top:0;right:0;padding:7px;background-color:#f66;color:#fff;border-radius:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./oauth-wrapper.scss
 ** module id = 381
 ** module chunks = 0
 **/